/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_No_DisplayInputs */

const vi_pos_no_display = /** @type {(inputs: Pos_No_DisplayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có màn hình`)
};

/**

* @param {Pos_No_DisplayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_no_display = /** @type {((inputs?: Pos_No_DisplayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_No_DisplayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_no_display(inputs)
});